exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Karla:400,700);", ""]);

// module
exports.push([module.id, "body{-moz-font-feature-settings:\"liga\" on;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;font-family:karla;font-style:normal;color:#464646;font-weight:400;font-size:16px;line-height:1.3;max-width:100%;overflow-x:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./client/css/type.css
// module id = 324
// module chunks = 0